function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Service from "@ember/service";
import Chart from "chart.js";
export default class ChartJSService extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "registered", false);
  }
  async register() {
    return import("chart.js").then(({
      Chart,
      LinearScale,
      LineController,
      LineElement,
      PointElement,
      TimeScale,
      Legend,
      Tooltip,
      Filler
    }) => {
      return import("chartjs-adapter-dayjs-3").then(() => {
        if (this.registered) return Chart;
        Chart.register(LineController, LinearScale, TimeScale, PointElement, LineElement, Legend, Tooltip, Filler);
        this.registered = true;
        return Chart;
      });
    });
  }
}